import React from "react";

import { isEmpty, get, filter } from "lodash";
import { Spacer, H5, Divider } from "orcs-design-system";
import { useAuth } from "src/contexts/global/GlobalContext";

import { useWorkspace } from "src/contexts/global/WorkspaceContext";

import ExternalAppLinks from "src/components/Nav/ExternalAppLinks";
import InternalAppLinks from "src/components/Nav/InternalAppLinks";
import { useAuth0 } from "src/contexts/auth0Provider";
import Restricted from "src/app/Restricted";

const AppSwitcherContent = () => {
  const auth = useAuth();
  const { user } = useAuth0();
  const { roles } = auth;
  const workspace = useWorkspace();
  const externalContents = get(workspace, "config.externalContents");
  const externalLinks = filter(externalContents, (c) => c.type === "link");
  let externalAppLinks = null;
  if (!isEmpty(externalLinks)) {
    externalAppLinks = <ExternalAppLinks links={externalLinks} />;
  }
  return (
    <Spacer mb="r">
      <H5 fontWeight="bold">Apps</H5>
      <Divider light />
      <Restricted>
        <InternalAppLinks user={user} roles={roles} workspace={workspace} />
        {externalAppLinks}
      </Restricted>
    </Spacer>
  );
};

export default AppSwitcherContent;
